import axios from '../utils/axios';

export default function getFeedTypes(adminId) {
    return axios.get(`/admin/${adminId}/xml-feeds`)
}
